import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type StatTone = "default" | "success" | "warning" | "danger";

const TONE_STYLES: Record<StatTone, string> = {
  default: "border-border bg-background/60",
  success: "border-emerald-500/40 bg-emerald-500/10",
  warning: "border-amber-400/40 bg-amber-500/10",
  danger: "border-rose-500/40 bg-rose-500/10",
};

const formatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });

export type MCStatCardProps = {
  label: string;
  value: number | string | null | undefined;
  hint?: string;
  tone?: StatTone;
  footer?: string | null;
};

export function MCStatCard({ label, value, hint, tone = "default", footer }: MCStatCardProps) {
  const resolved =
    typeof value === "number" && Number.isFinite(value)
      ? formatter.format(value)
      : value ?? (value === 0 ? "0" : "—");
  return (
    <Card className={cn("rounded-2xl border shadow-none", TONE_STYLES[tone])}>
      <CardHeader className="pb-2">
        <CardTitle className="text-xs uppercase tracking-wide text-muted-foreground">{label}</CardTitle>
        {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      </CardHeader>
      <CardContent>
        <p className="text-3xl font-semibold text-foreground">{resolved}</p>
        {footer && <p className="mt-2 text-xs text-muted-foreground">{footer}</p>}
      </CardContent>
    </Card>
  );
}

export default MCStatCard;
